(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory('cardFormService', Handler);

	function Handler() {

		var cardForms = {
			binary: {
				questionKeys: ['left', 'right'],
				templates: {
					none: ['', ''],
					emoji: ['👎', '👍']
				}
			},
			three: {
				questionKeys: ['left', 'right', 'bottom'],
				templates: {
					none: ['', '', ''],
					emoji: ['👎', '👍', '🤔']
				}
			},
			slider: {
				questionKeys: ['one', 'two', 'three', 'four', 'five'],
				templates: {
					none: ['', '', '', '', ''],
					emoji: ['😡', '😣', '😐', '😊', '😍'],
					satisfaction: ['Unsatisfied', 'Somewhat Unsatisfied', 'Indifferent', 'Somewhat Satisfied', 'Satisfied'],
					agreement: ['Strongly Disagree', 'Disagree', 'Undecided', 'Agree', 'Strongly Agree'],
					frequency: ['Never', 'Rarely', 'Occasionally', 'Frequently', 'Always']
				}
			}
		}

		function getTemplateAnswers(type, template) {
			if (!cardForms[type]) {
				return console.error('invalid card type');
			} else if (!cardForms[type].templates[template]) {
				return console.error('invalid template type');
			}
			return cardForms[type].templates[template];
		}

		function getQuestionKeys(type) {
			if (!cardForms[type]) return console.error('invalid card type');
			return cardForms[type].questionKeys;
		}

		function changeAnswerTemplate(card) {
			var template = card.answerTemplate;
			var answers = getTemplateAnswers(card.type, template);
			var questionKeys = getQuestionKeys(card.type);

			questionKeys.forEach(function(answerKey, index) {
				card[answerKey] = {
					choice: answers[index]
				}
			});
		}

		function getAnswerTemplates(type) {
			if (!cardForms[type]) return console.error('invalid card type');
			return Object.keys(cardForms[type].templates);
		}

		return {
			getAnswerTemplates: getAnswerTemplates,
			changeAnswerTemplate: changeAnswerTemplate
    }
	}

}());
